module.exports = __webpack_public_path__ + "img/inActiveHeart.89eebcb8.svg";